import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Rocket, ArrowRight, Sparkles } from 'lucide-react';
export function SparkCTA() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Sparkles className="mx-auto h-10 w-10 text-[#ffc857]" aria-hidden="true" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="mt-6 text-4xl font-black leading-[1.02] tracking-[-0.035em] sm:text-6xl">So easy you should just do it.<span className="block text-[#ff8a3d]">Pick a starter. Launch today.</span></h2>;
    t2 = <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-white/70">Use a playbook or starter, adapt it to your needs, and get your next initiative live.</p>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="/opportunities" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#ff8a3d] px-7 py-3.5 text-base font-black text-white transition-transform hover:-translate-y-0.5 cursor-pointer">Browse Opportunities<ArrowRight className="h-5 w-5" aria-hidden="true" /></Link>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="bg-[#211d4f] px-5 py-20 text-white sm:px-8 sm:py-24 lg:px-12"><div className="mx-auto max-w-[1100px] text-center">{t0}{t1}{t2}<div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">{t3}<Link href="/whatson" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 px-7 py-3.5 text-base font-black text-white transition-colors hover:bg-white/10 cursor-pointer">What's On<ArrowRight className="h-5 w-5" aria-hidden="true" /></Link></div></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}